// extracted by mini-css-extract-plugin
export default {"clickable":"OpenTaskWrapper_clickable__ISyUJ"};